import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import lazyload from "./features/lazy-load";
import proportionalScroll from "./features/proportional-scroll";
lazyload();
proportionalScroll();
initMain(
  [],
  {
    NewItoPager: () => import("./vue/components/new-ito-pager/NewItoPager.vue"),
    TrendsHorizontal: () =>
      import("./vue/components/trends/TrendsHorizontal.vue"),
  },
  []
);
header();
